// ProtectedRoute
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminArea = ({ children, allowedRoles }) => {
  const { user: currentUser } = useSelector((state) => state.auth);

  if (!currentUser) {
    return <Navigate to="/auth/login" />;
  }

  const hasAccess = currentUser?.roles?.some((role) =>
    allowedRoles.includes(role)
  );

  if (!hasAccess) {
    return <Navigate to="/status/404" />;
  }

  return children;
};

export default AdminArea;